import React, { createContext, useState } from "react";

const SelectedSubAccountContext = createContext({
    subAccountSelection: null,
    subAccountGroup: null,
    handleSelectedSubAccountUpdate: () => {},
    handleSelectedSubAccountNavUpdate: () => {},
    handleSelectedSubAccountsTabUpdate: () => {},
    handleSelectedSubAccountGroupUpdate: () => {},
});

export const SelectedSubAccountProvider = ({ children }) => {
    const [selectedSubAccount, setSelectedSubAccount] = useState("No Sub-Account Selected");
    const [selectedNavTab, setSelectedNavTab] = useState("0");
    const [selectedSubAccountsTab, setSelectedSubAccountsTab] = useState("0");
    const [selectedSubAccountGroup, setSelectedSubAccountGroup] = useState("");
    const handleSelectedSubAccountUpdate = selectedSubAccountUpdate => {
        setSelectedSubAccount(selectedSubAccountUpdate);
        if (selectedSubAccountUpdate !== "No Sub-Account Selected") {
            sessionStorage.setItem("selectedSubAccount", selectedSubAccountUpdate);
        }
    };
    const handleSelectedSubAccountNavUpdate = navUpdate => {
        setSelectedNavTab(navUpdate);
    };

    const handleSelectedSubAccountsTabUpdate = tabUpdate => {
        setSelectedSubAccountsTab(tabUpdate);
    };

    const handleSelectedSubAccountGroupUpdate = group => {
        setSelectedSubAccountGroup(group);
    };

    return (
        <>
            <SelectedSubAccountContext.Provider
                value={{
                    selectedSubAccount,
                    selectedNavTab,
                    selectedSubAccountsTab,
                    selectedSubAccountGroup,
                    handleSelectedSubAccountUpdate,
                    handleSelectedSubAccountNavUpdate,
                    handleSelectedSubAccountsTabUpdate,
                    handleSelectedSubAccountGroupUpdate,
                }}
            >
                {children}
            </SelectedSubAccountContext.Provider>
        </>
    );
};

export default SelectedSubAccountContext;
